import { useTranslation } from '~/shared/utils/translation';
import { usePage } from '~/templates/pages';
import styles from './ProductCategories.module.scss';
import { Typography } from '~/shared/components';
import clsx from 'clsx';
import NextLink from 'next/link';
import { Link } from '~/lib';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    onCategoryClick?(category: string): void;
}

export const ProductCategories: React.FC<Props> = ({ className, onCategoryClick, ...rest }) => {
    const { translate } = useTranslation();
    const { productCategoryLinks } = usePage();

    const evaluatedCategories = Object.values(productCategoryLinks ?? {}).filter(
        (link): link is Link & { url: string } => !!link && !!(link as Link).url,
    );

    if (!evaluatedCategories.length) return null;

    const title = translate('pdp.summary.categoriesTitle');

    return (
        <div className={clsx(styles.productCategories, className)} {...rest}>
            {title && (
                <Typography className={styles.productCategoriesTitle} variant="title-XS" as="h3">
                    {title}
                </Typography>
            )}

            <ul className={styles.productCategoriesList}>
                {evaluatedCategories.map((category) => (
                    <li key={category.id}>
                        <NextLink
                            className={styles.category}
                            href={category.url}
                            onClick={() => category.text && onCategoryClick?.(category.text)}
                        >
                            <Typography variant="paragraph-S" weight="medium">
                                {category.text}
                            </Typography>
                        </NextLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
